/* ReachModels theme — interactions */
(function () {
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      var isOpen = menu.hasAttribute('data-open');
      if (isOpen) {
        menu.removeAttribute('data-open');
        menu.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        menu.hidden = false;
        menu.setAttribute('data-open', '');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  if (document.readyState !== 'loading') {
    initMobileMenu();
  } else {
    document.addEventListener('DOMContentLoaded', initMobileMenu);
  }
})();
